<template>
  <b-container fluid class="padding-none mb-5">
    <div class="d-none d-md-block">
      <h1>{{ $t("login-app-main-title") }}</h1>
      <div class="d-flex flex-row">
        <div
          class="border-light-gray border mt-4 text-center"
          style="width:260px; height:260px; padding-top: 30px;"
        >
          <qrcode-vue
            class=" mx-auto"
            :value="JSON.stringify(qrcode)"
            size="200"
            level="H"
          ></qrcode-vue>
        </div>
        <div style="padding-top:20px; margin-left: -20px;">
          <img
            src="@/assets/images/QRcodeball.png"
            style="height:200px; width:200px; margin-top: 30px;"
          />
        </div>
      </div>
    </div>
    <div class="d-md-none d-block">
      <h1>{{ $t("login-app-press-button") }}</h1>
      <div>
        <a
          :disabled="loading"
          class="btn mb-5 bg-white border-black shadow-none w-100 mt-5"
          :href="appUrl"
        >
          {{ $t("login-app-go-to-app") }}
        </a>
      </div>
    </div>
    <p
      style="width:260px;"
      class="text-underscore text-dark-gray"
      @click="$router.push({ name: 'login-email' })"
    >
      <u>{{ $t("login-app-login-with-email") }}</u>
    </p>
  </b-container>
</template>
<script>
import { uuid } from "vue-uuid";
import QrcodeVue from "qrcode.vue";
import { env } from "@/env";

export default {
  name: "login-email",
  components: {
    QrcodeVue
  },
  data() {
    return {
      qrcode: {
        type: "login",
        data: {
          token: uuid.v1()
        }
      },
      qrcode_puller: null
    };
  },
  mounted: function() {
    this.$gtag.event("login_qr", { method: "Google" });
    this.qrcode_puller = setInterval(() => {
      this.checkQRLogin();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.qrcode_puller);
  },
  computed: {
    appUrl() {
      let url = encodeURIComponent(window.location.href);
      return `${env.VUE_APP_APP_PROTOCOL}://Login?loginToken=${this.qrcode.data.token}&sourceUrl=${url}#succes`;
    }
  },
  methods: {
    checkQRLogin() {
      this.$store
        .dispatch("auth/qrlogin", { code: this.qrcode.data.token })
        .then(() => {
          this.$router.push({ name: "overview" });
        })
        .catch(() => {
          setTimeout(function() {
            this.checkQRLogin();
          }, 5000);
        });
    }
  }
};
</script>
